import React, { useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { createBot } from "../services/botService";

function NewBot() {
	const [name, setName] = useState("");
	const [botFile, setBotFile] = useState(null);
	const [packageFile, setPackageFile] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [validated, setValidated] = useState(false);

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;

		if (form.checkValidity() === false) {
			e.stopPropagation();
			setValidated(true);
			return;
		}

		// File validations
		if (!botFile) {
			setError("Please upload a bot file");
			return;
		}

		if (!packageFile) {
			setError("Please upload a package.json file");
			return;
		}

		if (!botFile.name.endsWith(".js")) {
			setError("Bot file must be a JavaScript (.js) file");
			return;
		}

		if (packageFile.name !== "package.json") {
			setError("Package file must be named package.json");
			return;
		}

		setValidated(true);
		setLoading(true);
		setError(null);

		try {
			const formData = new FormData();
			formData.append("name", name);
			formData.append("botFile", botFile);
			formData.append("packageFile", packageFile);

			const bot = await createBot(formData);
			navigate(`/bots/${bot.id}`);
		} catch (error) {
			console.error("Failed to create bot:", error);
			setError(error.response?.data?.message || "Failed to create bot");
		} finally {
			setLoading(false);
		}
	};

	const handleBotFileChange = (e) => {
		setBotFile(e.target.files[0]);
	};

	const handlePackageFileChange = (e) => {
		setPackageFile(e.target.files[0]);
	};

	return (
		<div className="new-bot-page">
			<h1 className="mb-4">Add New Bot</h1>

			<Card>
				<Card.Body>
					{error && <Alert variant="danger">{error}</Alert>}

					<Form noValidate validated={validated} onSubmit={handleSubmit}>
						<Form.Group className="mb-3" controlId="formBotName">
							<Form.Label>Bot Name</Form.Label>
							<Form.Control type="text" placeholder="Enter bot name" value={name} onChange={(e) => setName(e.target.value)} required />
							<Form.Control.Feedback type="invalid">Please enter a bot name.</Form.Control.Feedback>
						</Form.Group>

						<Form.Group className="mb-3" controlId="formBotFile">
							<Form.Label>Bot File (.js)</Form.Label>
							<Form.Control type="file" onChange={handleBotFileChange} required accept=".js" />
							<Form.Text className="text-muted">Upload your Discord bot JavaScript file.</Form.Text>
							<Form.Control.Feedback type="invalid">Please upload a bot file.</Form.Control.Feedback>
						</Form.Group>

						<Form.Group className="mb-3" controlId="formPackageFile">
							<Form.Label>Package File (package.json)</Form.Label>
							<Form.Control type="file" onChange={handlePackageFileChange} required accept=".json" />
							<Form.Text className="text-muted">Upload your package.json file with all dependencies.</Form.Text>
							<Form.Control.Feedback type="invalid">Please upload a package.json file.</Form.Control.Feedback>
						</Form.Group>

						<Button variant="primary" type="submit" disabled={loading}>
							{loading ? "Creating..." : "Create Bot"}
						</Button>
					</Form>
				</Card.Body>
			</Card>
		</div>
	);
}

export default NewBot;
